<span *ngIf="header" class="card-title">{{ header | translate }}</span>
<span *ngIf="subheader" class="card-subtitle">{{ subheader | translate }}</span>
